import SplashPage from '@scoir/splash-page'

import PermissionLock from './PermissionLock.png'

export const NoPermissionsSplashPage = () => {
  return (
    <SplashPage
      subtitle="You don’t have permission to view this page"
      body="Contact your school’s administrator to grant you the appropriate access"
      artwork={PermissionLock}
      artworkProps={{ alt: 'No Permissions' }}
      showLearnMoreLink={false}
    />
  )
}

export default NoPermissionsSplashPage
